"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IConnext__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                indexed: false,
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "DiamondCut",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                indexed: false,
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "DiamondCutProposed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                indexed: false,
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "DiamondCutRescinded",
        type: "event",
    },
    {
        inputs: [],
        name: "LIQUIDITY_FEE_DENOMINATOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LIQUIDITY_FEE_NUMERATOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "aavePool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "aavePortalFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptProposedOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "acceptProposedRouterOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_connext",
                type: "address",
            },
        ],
        name: "addConnextion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "addRelayer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_local",
                type: "address",
            },
        ],
        name: "addRouterLiquidity",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_local",
                type: "address",
            },
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "addRouterLiquidityFor",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sequencer",
                type: "address",
            },
        ],
        name: "addSequencer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "address",
                name: "_stableSwapPool",
                type: "address",
            },
        ],
        name: "addStableSwapPool",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "minToMint",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "addSwapLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_adopted",
                type: "address",
            },
        ],
        name: "adoptedToCanonical",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
        ],
        name: "adoptedToLocalExternalPools",
        outputs: [
            {
                internalType: "contract IStableSwap",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
        ],
        name: "adoptedToLocalExternalPools",
        outputs: [
            {
                internalType: "contract IStableSwap",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "approveRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "approveRouterForPortal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
        ],
        name: "approvedAssets",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
        ],
        name: "approvedAssets",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "approvedRelayers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sequencer",
                type: "address",
            },
        ],
        name: "approvedSequencers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_transferId",
                type: "bytes32",
            },
        ],
        name: "bumpTransfer",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "calculateRemoveSwapLiquidity",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "tokenIndex",
                type: "uint8",
            },
        ],
        name: "calculateRemoveSwapLiquidityOneToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "tokenIndexFrom",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "tokenIndexTo",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "dx",
                type: "uint256",
            },
        ],
        name: "calculateSwap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "bool",
                name: "deposit",
                type: "bool",
            },
        ],
        name: "calculateSwapTokenAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
        ],
        name: "canonicalToAdopted",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
        ],
        name: "canonicalToAdopted",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
        ],
        name: "canonicalToRepresentation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
        ],
        name: "canonicalToRepresentation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "delay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "diamondCut",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "domain",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_id",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_custom",
                type: "address",
            },
        ],
        name: "enrollCustom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint32",
                                name: "originDomain",
                                type: "uint32",
                            },
                            {
                                internalType: "uint32",
                                name: "destinationDomain",
                                type: "uint32",
                            },
                            {
                                internalType: "uint32",
                                name: "canonicalDomain",
                                type: "uint32",
                            },
                            {
                                internalType: "address",
                                name: "to",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "delegate",
                                type: "address",
                            },
                            {
                                internalType: "bool",
                                name: "receiveLocal",
                                type: "bool",
                            },
                            {
                                internalType: "bytes",
                                name: "callData",
                                type: "bytes",
                            },
                            {
                                internalType: "uint256",
                                name: "slippage",
                                type: "uint256",
                            },
                            {
                                internalType: "address",
                                name: "originSender",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "bridgedAmt",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "normalizedIn",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "nonce",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "canonicalId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct TransferInfo",
                        name: "params",
                        type: "tuple",
                    },
                    {
                        internalType: "address[]",
                        name: "routers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes[]",
                        name: "routerSignatures",
                        type: "bytes[]",
                    },
                    {
                        internalType: "address",
                        name: "sequencer",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "sequencerSignature",
                        type: "bytes",
                    },
                ],
                internalType: "struct ExecuteArgs",
                name: "_args",
                type: "tuple",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_functionSelector",
                type: "bytes4",
            },
        ],
        name: "facetAddress",
        outputs: [
            {
                internalType: "address",
                name: "facetAddress_",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "facetAddresses",
        outputs: [
            {
                internalType: "address[]",
                name: "facetAddresses_",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_facet",
                type: "address",
            },
        ],
        name: "facetFunctionSelectors",
        outputs: [
            {
                internalType: "bytes4[]",
                name: "facetFunctionSelectors_",
                type: "bytes4[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "facets",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                internalType: "struct IDiamondLoupe.Facet[]",
                name: "facets_",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "originDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "destinationDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "canonicalDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "receiveLocal",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "slippage",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "originSender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "bridgedAmt",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "normalizedIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "canonicalId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TransferInfo",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "forceReceiveLocal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "originDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "destinationDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "canonicalDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "receiveLocal",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "slippage",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "originSender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "bridgedAmt",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "normalizedIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "canonicalId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TransferInfo",
                name: "_params",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_slippage",
                type: "uint256",
            },
        ],
        name: "forceUpdateSlippage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_transferId",
                type: "bytes32",
            },
        ],
        name: "getAavePortalDebt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_transferId",
                type: "bytes32",
            },
        ],
        name: "getAavePortalFeeDebt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "getAcceptanceTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
        ],
        name: "getCustodiedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_id",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "getLocalAndAdoptedToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "getProposedRouterOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "getProposedRouterOwnerTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "getRouterApproval",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "getRouterApprovalForPortal",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "getRouterOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "getRouterRecipient",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "getSwapA",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "getSwapAPrecise",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getSwapAdminBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "getSwapLPToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "getSwapStorage",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "key",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "initialA",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureA",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "initialATime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureATime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "swapFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adminFee",
                        type: "uint256",
                    },
                    {
                        internalType: "contract LPToken",
                        name: "lpToken",
                        type: "address",
                    },
                    {
                        internalType: "contract IERC20[]",
                        name: "pooledTokens",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "tokenPrecisionMultipliers",
                        type: "uint256[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "balances",
                        type: "uint256[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "adminFees",
                        type: "uint256[]",
                    },
                    {
                        internalType: "bool",
                        name: "disabled",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "removeTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct SwapUtils.Swap",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "index",
                type: "uint8",
            },
        ],
        name: "getSwapToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "index",
                type: "uint8",
            },
        ],
        name: "getSwapTokenBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "getSwapTokenIndex",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "getSwapVirtualPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_candidate",
                type: "address",
            },
        ],
        name: "getTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "_nonce",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "handle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
        ],
        name: "initializeRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_canonicalId",
                type: "bytes32",
            },
            {
                internalType: "contract IERC20[]",
                name: "_pooledTokens",
                type: "address[]",
            },
            {
                internalType: "uint8[]",
                name: "decimals",
                type: "uint8[]",
            },
            {
                internalType: "string",
                name: "lpTokenName",
                type: "string",
            },
            {
                internalType: "string",
                name: "lpTokenSymbol",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "_a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_fee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_adminFee",
                type: "uint256",
            },
        ],
        name: "initializeSwap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lpTokenTargetAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxRoutersPerTransfer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "proposeDiamondCut",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newlyProposed",
                type: "address",
            },
        ],
        name: "proposeNewOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proposeRouterAllowlistRemoval",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_proposed",
                type: "address",
            },
        ],
        name: "proposeRouterOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proposed",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposedTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "futureA",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "futureTime",
                type: "uint256",
            },
        ],
        name: "rampA",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "relayerFeeVault",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "remote",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "address",
                name: "_adoptedAssetId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_representation",
                type: "address",
            },
        ],
        name: "removeAssetId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_key",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_adoptedAssetId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_representation",
                type: "address",
            },
        ],
        name: "removeAssetId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "removeRelayer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeRouterAllowlist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "_to",
                type: "address",
            },
        ],
        name: "removeRouterLiquidity",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "_to",
                type: "address",
            },
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "removeRouterLiquidityFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sequencer",
                type: "address",
            },
        ],
        name: "removeSequencer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256[]",
                name: "minAmounts",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "removeSwapLiquidity",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "maxBurnAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "removeSwapLiquidityImbalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "tokenIndex",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "minAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "removeSwapLiquidityOneToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "originDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "destinationDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "canonicalDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "receiveLocal",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "slippage",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "originSender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "bridgedAmt",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "normalizedIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "canonicalId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TransferInfo",
                name: "_params",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_backingAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_feeAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_maxIn",
                type: "uint256",
            },
        ],
        name: "repayAavePortal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "originDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "destinationDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "canonicalDomain",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "receiveLocal",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "slippage",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "originSender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "bridgedAmt",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "normalizedIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "canonicalId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TransferInfo",
                name: "_params",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_backingAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_feeAmount",
                type: "uint256",
            },
        ],
        name: "repayAavePortalFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_adopted",
                type: "address",
            },
        ],
        name: "representationToCanonical",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "enum IDiamondCut.FacetCutAction",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                internalType: "struct IDiamondCut.FacetCut[]",
                name: "_diamondCut",
                type: "tuple[]",
            },
            {
                internalType: "address",
                name: "_init",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "rescindDiamondCut",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_transferId",
                type: "bytes32",
            },
        ],
        name: "routedTransfers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "routerAllowlistRemoved",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "routerAllowlistTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
        ],
        name: "routerBalances",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_aavePool",
                type: "address",
            },
        ],
        name: "setAavePool",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_aavePortalFeeNumerator",
                type: "uint256",
            },
        ],
        name: "setAavePortalFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_numerator",
                type: "uint256",
            },
        ],
        name: "setLiquidityFeeNumerator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_newMaxRouters",
                type: "uint256",
            },
        ],
        name: "setMaxRoutersPerTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayerFeeVault",
                type: "address",
            },
        ],
        name: "setRelayerFeeVault",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
        ],
        name: "setRouterRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "newAdminFee",
                type: "uint256",
            },
        ],
        name: "setSwapAdminFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "newSwapFee",
                type: "uint256",
            },
        ],
        name: "setSwapFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_xAppConnectionManager",
                type: "address",
            },
        ],
        name: "setXAppConnectionManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "uint8",
                name: "_canonicalDecimals",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_representationName",
                type: "string",
            },
            {
                internalType: "string",
                name: "_representationSymbol",
                type: "string",
            },
            {
                internalType: "address",
                name: "_adoptedAssetId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stableSwapPool",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_cap",
                type: "uint256",
            },
        ],
        name: "setupAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "address",
                name: "_representation",
                type: "address",
            },
            {
                internalType: "address",
                name: "_adoptedAssetId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stableSwapPool",
                type: "address",
            },
        ],
        name: "setupAssetWithDeployedRepresentation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "stopRampA",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "tokenIndexFrom",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "tokenIndexTo",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "dx",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minDy",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "assetIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "assetOut",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "minAmountOut",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapExact",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "assetIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "assetOut",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maxAmountIn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapExactOut",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_transferId",
                type: "bytes32",
            },
        ],
        name: "transferStatus",
        outputs: [
            {
                internalType: "enum DestinationTransferStatus",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "unapproveRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
        ],
        name: "unapproveRouterForPortal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        name: "updateDetails",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                ],
                internalType: "struct TokenId",
                name: "_canonical",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_updated",
                type: "uint256",
            },
        ],
        name: "updateLiquidityCap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateLpTokenTarget",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "canonicalId",
                type: "bytes32",
            },
        ],
        name: "withdrawSwapAdminFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "xAppConnectionManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_delegate",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_slippage",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_callData",
                type: "bytes",
            },
        ],
        name: "xcall",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_delegate",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_slippage",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_callData",
                type: "bytes",
            },
        ],
        name: "xcallIntoLocal",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
];
class IConnext__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IConnext__factory = IConnext__factory;
IConnext__factory.abi = _abi;
//# sourceMappingURL=IConnext__factory.js.map